import { updateRecord } from '@ms/yammer-data-support';
import type { GraphqlErrorReason } from '@ms/yammer-libs-api';

import { getGraphqlApiErrorCode } from '../../api/errors';
import type { Publishers } from '../types';

import type { PublishersAction } from './reducer.types';

interface ModerationPayload {
  readonly publisherId: string;
  readonly error: unknown;
  readonly errorCode?: GraphqlErrorReason | null;
}

const handleModerationBlocking = (state: Publishers, payload: ModerationPayload): Publishers => {
  const errorCode = getGraphqlApiErrorCode(payload);

  if (errorCode === 'POST_BLOCKED_BY_MODERATION') {
    return updateRecord(state, payload.publisherId, {
      isBlockedByModeration: true,
    });
  }

  return state;
};

export const moderationActionsReducer = (state: Publishers, action: PublishersAction): Publishers => {
  switch (action.type) {
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_REJECTED': {
      return handleModerationBlocking(state, action.payload);
    }
    default:
      return state;
  }
};
